import React from "react";


export const SectionHeader = () => {
  return <div className="section-header"></div>;
};